import { connect } from 'react-redux';
import AccountActions from 'public/redux/account/actions';

import GetFlashView from './GetFlashView';

const mapStateToProps = ({ account }) => account;
const mapDispatchToProps = {
  getFlashUser: AccountActions.getFlashUser,
  setRedirectTo: AccountActions.setRedirectTo,
};

export default connect(mapStateToProps, mapDispatchToProps)(GetFlashView);

